import React from "react";
import { NavLink } from "react-router-dom";
import {
  SquaresFour, Users, Kanban, ListChecks, Receipt,
  Sparkle, ChartLineUp, GearSix, Buildings,
} from "@phosphor-icons/react";

const NAV = [
  { to: "/", label: "Dashboard", icon: SquaresFour, end: true, testid: "sidebar-nav-dashboard" },
  { to: "/customers", label: "Customers", icon: Users, testid: "sidebar-nav-customers" },
  { to: "/leads", label: "Leads", icon: Kanban, testid: "sidebar-nav-leads" },
  { to: "/tasks", label: "Tasks", icon: ListChecks, testid: "sidebar-nav-tasks" },
  { to: "/quotes", label: "Quotes & Invoices", icon: Receipt, testid: "sidebar-nav-quotes" },
  { to: "/ai", label: "AI Assistant", icon: Sparkle, testid: "sidebar-nav-ai" },
  { to: "/reports", label: "Reports", icon: ChartLineUp, testid: "sidebar-nav-reports" },
  { to: "/settings", label: "Settings", icon: GearSix, testid: "sidebar-nav-settings" },
];

export default function Sidebar() {
  return (
    <aside
      className="hidden lg:flex flex-col w-[240px] shrink-0 border-r border-border glass h-screen sticky top-0"
      data-testid="sidebar"
    >
      <div className="px-6 pt-7 pb-6 border-b border-border/60">
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-md bg-primary/15 hairline-border flex items-center justify-center">
            <Buildings size={18} weight="duotone" className="text-primary" />
          </div>
          <div className="leading-tight">
            <div className="font-display text-lg tracking-tight">Zippé</div>
            <div className="overline -mt-0.5">CRM · v1</div>
          </div>
        </div>
      </div>

      <nav className="px-3 pt-5 flex-1 space-y-0.5">
        <div className="overline px-3 mb-2">Workspace</div>
        {NAV.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            data-testid={item.testid}
            className={({ isActive }) =>
              `group flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-all duration-200
               ${isActive
                 ? "bg-primary/10 text-foreground hairline-border"
                 : "text-muted-foreground hover:bg-muted/60 hover:text-foreground"}`
            }
          >
            {({ isActive }) => (
              <>
                <item.icon size={18} weight={isActive ? "fill" : "duotone"} className={isActive ? "text-primary" : ""} />
                <span className="tracking-wide">{item.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </nav>

      <div className="p-4 m-3 mt-auto rounded-xl ai-glow bg-card/60">
        <div className="flex items-center gap-2 mb-1">
          <Sparkle size={14} weight="fill" className="text-primary" />
          <div className="overline">Zippé AI</div>
        </div>
        <p className="text-xs text-muted-foreground leading-relaxed">
          Ask anything about your pipeline. Forecasts, drafts, summaries.
        </p>
      </div>
    </aside>
  );
}
